export type AppLocale = 'fr' | 'en'

export const APP_LOCALES = [
  { code: 'en' as const, label: 'EN', flag: 'EN.svg', full: 'English' },
  { code: 'fr' as const, label: 'FR', flag: 'FR.svg', full: 'Français' },
] as const

export function normalizeAppLocale(input: unknown): AppLocale {
  if (input === 'fr' || input === 'en') {
    return input
  }
  if (typeof input === 'string') {
    const lower = input.trim().toLowerCase()
    if (lower === 'fr' || lower.startsWith('fr-') || lower.startsWith('fr_')) {
      return 'fr'
    }
    if (lower === 'en' || lower.startsWith('en-') || lower.startsWith('en_')) {
      return 'en'
    }
  }
  return 'en'
}

export function getLocaleMeta(code: AppLocale) {
  return APP_LOCALES.find((l) => l.code === code) ?? APP_LOCALES[0]
}
